<template>
    <Dialog
        :value="true"
        :header-text="$t('Edit comment')"
        persistent
        @close_modal="$emit('close')"
    >
        <v-container>
            <text-area-field
                autofocus
                :value="valueCopy"
                :max-length="255"
                @input="valueCopy = $event"
            />
        </v-container>
        <template slot="footer">
            <v-spacer />
            <secondary-button @click="$emit('close')">
                {{ $t("Cancel") }}
            </secondary-button>
            <primary-button @click="save">
                {{ $t("Save") }}
            </primary-button>
        </template>
    </Dialog>
</template>

<script>
import { $t } from "@/i18n";
import Dialog from "../../components/Dialog.vue";
import {ref} from "@vue/composition-api";
import errorDialog from "@/views/ErrorDialog/errorDialog";
import ApiTimeEntry from "@/api/time_entry/timeEntry";
import {formatSysDateTime} from "@/plugins/formatting";

export default {
    name: "EditReportTimeEntryDescription",
    components: {
        Dialog
    },
    props: {
        timeEntry: {
            type: Object,
            required: true
        }
    },
    setup(props, ctx) {
        const valueCopy = ref(null);

        valueCopy.value = props.timeEntry.description

        const save = async () => {
            try {
                const timeEntryCopy = { ...props.timeEntry }

                timeEntryCopy.description = valueCopy.value.trim()
                await ApiTimeEntry.saveTimeEntry(timeEntryCopy)
                ctx.emit('close')
            } catch (e) {
                errorDialog.showError(e)
            }
        }

        return {
            valueCopy,
            save
        }
    }
};
</script>
